var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2372"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2372"
    },
    "bundlingPackage": "InpageEditorUI",
    "bundlingPackageVersion": "static-1.86359",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};